import React from "react";
import Component from "./component";
import WithApi from "../../common/withApi";

export default (props) => {
  if (!global.RunningGame) {
    return null;
  }
  const name = global.RunningGame.name;
  const gameId = global.RunningGame.game.id;

  return (
    <WithApi {...props}>
      <Component
        key={`${name}:${gameId}`}
        name={name}
        gameId={gameId}
        {...props}
      />
    </WithApi>
  );
};
